export const countryList = [
    {
        currency: "AUD",
        flag: "🇦🇺",
        isoCode: "AU",
        latitude: "-27.00000000",
        longitude: "133.00000000",
        name: "Australia",
        phonecode: "61",
        timezones: [
            {
                abbreviation: "MIST",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Macquarie Island Station Time",
                zoneName: "Antarctica/Macquarie"
            },
            {
                abbreviation: "ACDT",
                gmtOffset: 37800,
                gmtOffsetName: "UTC+10:30",
                tzName: "Australian Central Daylight Saving Time",
                zoneName: "Australia/Adelaide"
            },
            {
                abbreviation: "AEST",
                gmtOffset: 36000,
                gmtOffsetName: "UTC+10:00",
                tzName: "Australian Eastern Standard Time",
                zoneName: "Australia/Brisbane"
            },
            {
                abbreviation: "ACDT",
                gmtOffset: 37800,
                gmtOffsetName: "UTC+10:30",
                tzName: "Australian Central Daylight Saving Time",
                zoneName: "Australia/Broken_Hill"
            },
            {
                abbreviation: "AEDT",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Australian Eastern Daylight Saving Time",
                zoneName: "Australia/Currie"
            },
            {
                abbreviation: "ACST",
                gmtOffset: 34200,
                gmtOffsetName: "UTC+09:30",
                tzName: "Australian Central Standard Time",
                zoneName: "Australia/Darwin"
            },
            {
                abbreviation: "ACWST",
                gmtOffset: 31500,
                gmtOffsetName: "UTC+08:45",
                tzName: "Australian Central Western Standard Time (Unofficial)",
                zoneName: "Australia/Eucla"
            },
            {
                abbreviation: "AEDT",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Australian Eastern Daylight Saving Time",
                zoneName: "Australia/Hobart"
            },
            {
                abbreviation: "AEST",
                gmtOffset: 36000,
                gmtOffsetName: "UTC+10:00",
                tzName: "Australian Eastern Standard Time",
                zoneName: "Australia/Lindeman"
            },
            {
                abbreviation: "LHST",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Lord Howe Summer Time",
                zoneName: "Australia/Lord_Howe"
            },
            {
                abbreviation: "AEDT",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Australian Eastern Daylight Saving Time",
                zoneName: "Australia/Melbourne"
            },
            {
                abbreviation: "AWST",
                gmtOffset: 28800,
                gmtOffsetName: "UTC+08:00",
                tzName: "Australian Western Standard Time",
                zoneName: "Australia/Perth"
            },
            {
                abbreviation: "AEDT",
                gmtOffset: 39600,
                gmtOffsetName: "UTC+11:00",
                tzName: "Australian Eastern Daylight Saving Time",
                zoneName: "Australia/Sydney"
            }
        ]
    },
    {
        currency: "CAD",
        flag: "🇨🇦",
        isoCode: "CA",
        latitude: "60.00000000",
        longitude: "-95.00000000",
        name: "Canada",
        phonecode: "1",
        timezones: [
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America)",
                zoneName: "America/Atikokan"
            },
            {
                abbreviation: "AST",
                gmtOffset: -14400,
                gmtOffsetName: "UTC-04:00",
                tzName: "Atlantic Standard Time",
                zoneName: "America/Blanc-Sablon"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Cambridge_Bay"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Creston"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Dawson"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Dawson_Creek"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Edmonton"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America)",
                zoneName: "America/Fort_Nelson"
            },
            {
                abbreviation: "AST",
                gmtOffset: -14400,
                gmtOffsetName: "UTC-04:00",
                tzName: "Atlantic Standard Time",
                zoneName: "America/Glace_Bay"
            },
            {
                abbreviation: "AST",
                gmtOffset: -14400,
                gmtOffsetName: "UTC-04:00",
                tzName: "Atlantic Standard Time",
                zoneName: "America/Goose_Bay"
            },
            {
                abbreviation: "AST",
                gmtOffset: -14400,
                gmtOffsetName: "UTC-04:00",
                tzName: "Atlantic Standard Time",
                zoneName: "America/Halifax"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Inuvik"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Iqaluit"
            },
            {
                abbreviation: "AST",
                gmtOffset: -14400,
                gmtOffsetName: "UTC-04:00",
                tzName: "Atlantic Standard Time",
                zoneName: "America/Moncton"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Nipigon"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Pangnirtung"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Rainy_River"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Rankin_Inlet"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Regina"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Resolute"
            },
            {
                abbreviation: "NST",
                gmtOffset: -12600,
                gmtOffsetName: "UTC-03:30",
                tzName: "Newfoundland Standard Time",
                zoneName: "America/St_Johns"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Swift_Current"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Thunder_Bay"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Toronto"
            },
            {
                abbreviation: "PST",
                gmtOffset: -28800,
                gmtOffsetName: "UTC-08:00",
                tzName: "Pacific Standard Time (North America",
                zoneName: "America/Vancouver"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Whitehorse"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Winnipeg"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Yellowknife"
            }
        ]
    },
    {
        currency: "GBP",
        flag: "🇬🇧",
        isoCode: "GB",
        latitude: "54.00000000",
        longitude: "-2.00000000",
        name: "United Kingdom",
        phonecode: "44",
        timezones: [
            {
                abbreviation: "GMT",
                gmtOffset: 0,
                gmtOffsetName: "UTC±00",
                tzName: "Greenwich Mean Time",
                zoneName: "Europe/London"
            }
        ]
    },
    {
        currency: "USD",
        flag: "🇺🇸",
        isoCode: "US",
        latitude: "38.00000000",
        longitude: "-97.00000000",
        name: "United States",
        phonecode: "1",
        timezones: [
            {
                abbreviation: "HST",
                gmtOffset: -36000,
                gmtOffsetName: "UTC-10:00",
                tzName: "Hawaii–Aleutian Standard Time",
                zoneName: "America/Adak"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Anchorage"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Boise"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Chicago"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Denver"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Detroit"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Indianapolis"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Indiana/Knox"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Marengo"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Petersburg"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Indiana/Tell_City"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Vevay"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Vincennes"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Indiana/Winamac"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Juneau"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Kentucky/Louisville"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/Kentucky/Monticello"
            },
            {
                abbreviation: "PST",
                gmtOffset: -28800,
                gmtOffsetName: "UTC-08:00",
                tzName: "Pacific Standard Time (North America",
                zoneName: "America/Los_Angeles"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/Menominee"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Metlakatla"
            },
            {
                abbreviation: "EST",
                gmtOffset: -18000,
                gmtOffsetName: "UTC-05:00",
                tzName: "Eastern Standard Time (North America",
                zoneName: "America/New_York"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Nome"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/North_Dakota/Beulah"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/North_Dakota/Center"
            },
            {
                abbreviation: "CST",
                gmtOffset: -21600,
                gmtOffsetName: "UTC-06:00",
                tzName: "Central Standard Time (North America",
                zoneName: "America/North_Dakota/New_Salem"
            },
            {
                abbreviation: "MST",
                gmtOffset: -25200,
                gmtOffsetName: "UTC-07:00",
                tzName: "Mountain Standard Time (North America",
                zoneName: "America/Phoenix"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Sitka"
            },
            {
                abbreviation: "AKST",
                gmtOffset: -32400,
                gmtOffsetName: "UTC-09:00",
                tzName: "Alaska Standard Time",
                zoneName: "America/Yakutat"
            },
            {
                abbreviation: "HST",
                gmtOffset: -36000,
                gmtOffsetName: "UTC-10:00",
                tzName: "Hawaii–Aleutian Standard Time",
                zoneName: "Pacific/Honolulu"
            }
        ]
    }
];
